import React from 'react';
import { Avatar } from '@companycam/slab-web';
import { useCurrentUser } from 'javascripts/hooks';
import { AssignedUserObject } from 'data/v3/data-contracts';
import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

type AssignedUserAvatarsProps = {
  assignedUsers: AssignedUserObject[];
};

export const MAX_NUM_AVATARS = 3;

const AssignedUsersAvatars = ({ assignedUsers }: AssignedUserAvatarsProps) => {
  const currentUser = useCurrentUser();

  const usersToShow = assignedUsers.slice(0, MAX_NUM_AVATARS - 1);
  const remainingUserCount = assignedUsers.length - usersToShow.length;

  const hiddenUsers = assignedUsers.slice(MAX_NUM_AVATARS - 1);
  const isCurrentUserHidden = hiddenUsers.some(
    (user) => user.id === currentUser.id,
  );

  return (
    <Row>
      {usersToShow.map((user) => (
        <Avatar
          key={user.id}
          fullName={user.fullName}
          initials={user.initials}
          size="small"
          borderColor={
            user.id === currentUser.id ? 'var(--cc_color_utility_assigned)' : ''
          }
        />
      ))}

      {remainingUserCount > 0 ? (
        <Avatar
          fullName={`${remainingUserCount}+`}
          initials={`${remainingUserCount}+`}
          size="small"
          borderColor={
            isCurrentUserHidden ? 'var(--cc_color_utility_assigned)' : ''
          }
        />
      ) : null}
    </Row>
  );
};

export default AssignedUsersAvatars;
